import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { adminApi } from "@/api/admin";

export const Route = createFileRoute("/admin/audit")({
  component: AdminAuditPage,
});

function AdminAuditPage() {
  const [target, setTarget] = useState("");
  const { data, isLoading } = useQuery({
    queryKey: ["admin-audit", target],
    queryFn: () => adminApi.audit({ target_type: target || undefined, limit: 500 }),
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Audit log</h1>
        <p className="mt-1 text-ink/65">Append-only record of every admin operation (CLI + dashboard).</p>
      </div>

      <select className="input w-60" value={target} onChange={(e) => setTarget(e.target.value)}>
        <option value="">All targets</option>
        <option value="project">project</option>
        <option value="user">user</option>
        <option value="payment">payment</option>
        <option value="api_key">api_key</option>
        <option value="session">session</option>
      </select>

      <div className="card overflow-x-auto p-0">
        <table className="w-full text-sm">
          <thead className="bg-cream text-left text-xs uppercase tracking-wide text-ink/55">
            <tr>
              <th className="px-4 py-3">When</th>
              <th className="px-4 py-3">Action</th>
              <th className="px-4 py-3">Target</th>
              <th className="px-4 py-3">Actor</th>
              <th className="px-4 py-3">Details</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? <tr><td colSpan={5} className="px-4 py-6 text-ink/55">Loading…</td></tr>
            : data?.rows.length ? data.rows.map((r) => (
              <tr key={r.id} className="border-t border-ink/8 align-top">
                <td className="px-4 py-3 text-xs text-ink/55">{new Date(r.created_at).toLocaleString()}</td>
                <td className="px-4 py-3 font-mono text-xs">{r.action}</td>
                <td className="px-4 py-3 text-xs">
                  <div>{r.target_type}</div>
                  <div className="text-ink/45">{r.target_id.slice(0, 8)}…</div>
                </td>
                <td className="px-4 py-3 text-xs font-mono text-ink/55">
                  {r.actor_user_id ? r.actor_user_id.slice(0, 8) + "…" : <span className="text-ink/45">CLI</span>}
                </td>
                <td className="px-4 py-3">
                  <details>
                    <summary className="cursor-pointer text-xs text-primary-600">json</summary>
                    <pre className="mt-2 overflow-x-auto rounded bg-cream p-2 font-mono text-xs">{JSON.stringify(r.details, null, 2)}</pre>
                  </details>
                </td>
              </tr>
            )) : <tr><td colSpan={5} className="px-4 py-6 text-ink/55">No rows.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
